import {FilterMatchMode, FilterOperator} from "primereact/api";
import {
    CLEAR_TRUNK_STATISTICS_FILTERS,
    SET_TRUNK_STATISTICS_UI_FILTERS,
    GET_TRUNK_STATISTIC,
    GET_TRUNK_STATISTICS,
    GET_TRUNK_STATISTICS_PAGINATION,
    INITIAL_TRUNK_STATISTICS_DATA,
    SET_CURRENT_TRUNK_STATISTICS_PAGE,
    SET_CURRENT_TRUNK_STATISTICS_SIZE,
    SET_TRUNK_STATISTICS_FILTER,
    SET_TRUNK_STATISTICS_LOADING,
    SHOW_EXPORT_TRUNK_STATISTICS_LOADING,
    UPDATE_TRUNK_STATISTIC_FILTER,
    GET_TRUNK_STATISTICS_FILES_HISTORY,
    SET_TRUNK_STATISTICS_FILES_HISTORY_LOADER,
    GET_TRUNK_STATISTICS_FILES_PAGINATION,
    SET_CURRENT_TRUNK_STATISTICS_FILES_PAGE,
    SET_CURRENT_TRUNK_STATISTICS_FILES_SIZE,
} from "../types/typesTrunkStatisticsList";

const initialState = {
    clearFilters: {
        id: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
        number: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
    },
    trunkStatisticsList: null as any,
    pagination: {
        hasNext: 0,
        pageNumber: 0,
    },
    paginationPage: 1,
    paginationSize: 10,
    loading: false,
    exportLoading: false,
    trunkStatisticsFilterData: null,
    statisticTrunkData: null as any,
    filesHistory: [] as any[],
    filesHistoryLoader: false,
    filesPagination: {
        hasNext: 0,
        pageNumber: 0,
    },
    filesPaginationPage: 1,
    filesPaginationSize: 10,
};

const initialStatisticTrunkData = {
    id: null,
    number: null,
    totalCallsCount: null,
    totalCallsDuration: null,
    incomingCallsCount: null,
    incomingCallsDuration: null,
    outgoingCallsCount: null,
    outgoingCallsDuration: null,
};

export const TrunkStatisticsListReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case CLEAR_TRUNK_STATISTICS_FILTERS:
            return {
                ...state,
                clearFilters: {
                    id: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
                    number: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
                },
            };
        case SET_TRUNK_STATISTICS_UI_FILTERS: {
            const nextFilters = { ...state.clearFilters };
            Object.entries(action.payload || {}).forEach(([filterField, filterValue]) => {
                // @ts-ignore
                const existingFilter = nextFilters[filterField];
                if (!existingFilter) return;
                if ('constraints' in existingFilter) {
                    // @ts-ignore
                    nextFilters[filterField] = {
                        ...existingFilter,
                        constraints: [
                            {
                                ...existingFilter.constraints[0],
                                value: filterValue
                            }
                        ]
                    };
                } else {
                    // @ts-ignore
                    nextFilters[filterField] = {
                        ...existingFilter,
                        value: filterValue
                    };
                }
            });
            return {
                ...state,
                clearFilters: nextFilters
            };
        }
        case GET_TRUNK_STATISTICS:
            if (action.payload === null) {
                return {
                    ...state,
                    trunkStatisticsList: null,
                    pagination: {
                        hasNext: 0,
                        pageNumber: 0,
                    },
                    paginationPage: 1,
                };
            }
            return {...state, trunkStatisticsList: action.payload};
        case GET_TRUNK_STATISTIC:
            return {...state, statisticTrunkData: action.payload};
        case INITIAL_TRUNK_STATISTICS_DATA:
            return {...state, statisticTrunkData: initialStatisticTrunkData};
        case GET_TRUNK_STATISTICS_PAGINATION:
            return {...state, pagination: {hasNext: action.payload.hasNext, pageNumber: action.payload.pageNumber}};
        case SET_CURRENT_TRUNK_STATISTICS_PAGE:
            return {...state, paginationPage: action.payload};
        case SET_CURRENT_TRUNK_STATISTICS_SIZE:
            return {...state, paginationSize: action.payload};
        case SET_TRUNK_STATISTICS_LOADING:
            return {...state, loading: action.payload};
        case SHOW_EXPORT_TRUNK_STATISTICS_LOADING:
            return {...state, exportLoading: action.payload};
        case SET_TRUNK_STATISTICS_FILTER:
            return {...state, trunkStatisticsFilterData: action.payload};
        case GET_TRUNK_STATISTICS_FILES_HISTORY:
            return {...state, filesHistory: Array.isArray(action.payload) ? [...action.payload] : []};
        case SET_TRUNK_STATISTICS_FILES_HISTORY_LOADER:
            return {...state, filesHistoryLoader: action.payload};
        case GET_TRUNK_STATISTICS_FILES_PAGINATION:
            return {...state, filesPagination: {hasNext: action.payload.hasNext, pageNumber: action.payload.pageNumber}};
        case SET_CURRENT_TRUNK_STATISTICS_FILES_PAGE:
            return {...state, filesPaginationPage: action.payload};
        case SET_CURRENT_TRUNK_STATISTICS_FILES_SIZE:
            return {...state, filesPaginationSize: action.payload};
        case UPDATE_TRUNK_STATISTIC_FILTER: {
            const {field, value} = action.payload;
            const currentFilter = (state.clearFilters as any)[field];

            if (!currentFilter) return state;

            let updatedField;

            if ('constraints' in currentFilter) {
                updatedField = {
                    ...currentFilter,
                    constraints: [
                        {
                            ...currentFilter.constraints[0],
                            value,
                        },
                    ],
                };
            } else {
                updatedField = {
                    ...currentFilter,
                    value,
                };
            }

            return {
                ...state,
                clearFilters: {
                    ...state.clearFilters,
                    [field]: updatedField,
                },
            };
        }
        default:
            return state;
    }
};
